import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { BackHeaderComponent } from '@app/back-header/back-header.component';
import { RecursiveInterface } from '@app/services/base-authenticated.service';
import { CorrispettiviReceiptsApi } from '@app/services/corrispettivi-receipts-api.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'izy-corrispettivi-receipts-detail',
  templateUrl: './corrispettivi-receipts-details.component.html',
  styleUrl: './corrispettivi-receipts-details.component.scss',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    BackHeaderComponent,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatProgressSpinnerModule,
    DatePipe,
  ],
  providers: [DatePipe],
})
export class CorrispettiviReceiptsDetailComponent implements OnInit {
  receiptForm: FormGroup;
  receiptId: number;
  isLoading = true;

  formatOptions = [
    { code: 'COR10', name: 'Versione 1.0 (Standard)' },
    { code: 'COR20', name: 'Versione 2.0 (Avanzata)' },
  ];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private service: CorrispettiviReceiptsApi,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private snackBar: MatSnackBar,
    private datePipe: DatePipe,
  ) {
    this.receiptForm = this.fb.group({
      // Metadata & Transmission
      format: [{ value: 'COR10', readonly: true }, Validators.required],
      device_id: [{ value: '', readonly: true }],
      progressive_number: [{ value: 1, readonly: true }],
      detection_date: [{ value: null, readonly: true }],
      transmission_date: [{ value: null, readonly: true }],
      // detection_date: [new Date(), Validators.required],

      // Financials
      amount: [0, [Validators.required, Validators.min(0)]],
      partial_amount: [0],
      vat_amount: [0, Validators.required],
      vat_percentage: [22.0],
      vat_nature: [''],

      // Totals
      n_docs: [0, [Validators.required, Validators.min(1)]],
      paid_cash: [0],
      paid_electronic: [0],
      discount: [0],

      organization_id: [null],
    });

    this.receiptId = +this.route.snapshot.params['id'];
  }

  ngOnInit(): void {
    this.loadReceiptData();
  }

  private loadReceiptData(): void {
    const orgId = Number(this.route.snapshot.paramMap.get('organizationId'));

    this.isLoading = true;

    this.service.getAllCorrispettiviReceipts(orgId, {}).subscribe({
      next: (response: any) => {
        // Nota: Gestiamo il fatto che la risposta sia paginata (results)
        const results = response.results || response;
        const data = results.find(
          (r: any) => Number(r.id) === Number(this.receiptId),
        );

        if (data) {
          // console.log('data', data);
          this.receiptForm.patchValue({
            ...data,
            organization_id: orgId,
          });
          this.isLoading = false;
        } else if (response.completed) {
          // not found (really!) when results are completed
          this.isLoading = false;
          this.showErrorMessage('Corrispettivo non trovato');
          this.onCancel();
        }
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error(err);
        this.showErrorMessage('Errore nel caricamento del record.');
        this.onCancel();
      },
    });
  }

  // onSubmit(): void {
  //   const orgId = Number(this.route.snapshot.paramMap.get('organizationId'));

  //   if (this.receiptForm.valid) {
  //     this.isLoading = true;
  //     this.service
  //       .updateCorrispettiviReceipt(
  //         orgId,
  //         this.receiptId,
  //         this.receiptForm.value,
  //       )
  //       .subscribe({
  //         next: () => {
  //           this.isLoading = false;
  //           this.showSuccessMessage('Dati aggiornati con successo!');
  //           this.onCancel();
  //         },
  //         error: (err) => {
  //           this.isLoading = false;
  //           this.showErrorMessage('Errore durante il salvataggio.');
  //         },
  //       });
  //   }
  // }

  formatFormDate(controlName: string): string {
    const dateValue = this.receiptForm.get(controlName)?.value;
    if (!dateValue) return '';

    // transforms ISO into readable format (dd/MM/yyyy)
    return this.datePipe.transform(dateValue, 'dd/MM/yyyy') || '';
  }

  onCancel(): void {
    const orgId = this.route.snapshot.paramMap.get('organizationId');
    this.router.navigate([`/${orgId}/corrispettivi-receipts`]);
  }

  private showSuccessMessage(message: string): void {
    this.snackBar.open(message, 'Chiudi', {
      duration: 3000,
      panelClass: ['success-snackbar'],
    });
  }

  private showErrorMessage(message: string): void {
    this.snackBar.open(message, 'Chiudi', {
      duration: 3000,
      panelClass: ['error-snackbar'],
    });
  }
}
